import { useState } from 'react';

/**
 * Custom hook for managing cancellation form state
 * @returns {object} Form state and handlers
 */
export const useCancelFormState = () => {
  const [selectedReason, setSelectedReason] = useState('');
  const [otherReasonText, setOtherReasonText] = useState('');
  const [cancelRequestId, setCancelRequestId] = useState(self.crypto.randomUUID());

  const handleReasonChange = event => {
    setSelectedReason(event.target.value);
    // Clear other reason text if not selecting "other"
    if (event.target.value !== 'other') {
      setOtherReasonText('');
    }
  };

  const handleOtherReasonChange = event => {
    setOtherReasonText(event.target.value);
  };

  const resetForm = () => {
    setSelectedReason('');
    setOtherReasonText('');
    setCancelRequestId(self.crypto.randomUUID());
  };

  // Validation: reason must be selected and if "other" is selected, text must be provided
  const isValid = selectedReason && (selectedReason !== 'other' || otherReasonText?.trim());

  return {
    selectedReason,
    otherReasonText,
    cancelRequestId,
    handleReasonChange,
    handleOtherReasonChange,
    resetForm,
    isValid
  };
};
